export class ChannelDTO {
  id: number;
  name: string;
  supportsStockLimits: boolean;
  supportsAutomaticDiscounts: boolean;
  supportsManualDiscounts: boolean;
  supportsChannelDiscounts: boolean;
  supportsVouchers: boolean;
  supportsPreOrders: boolean;
  supportsPreOrderOnShiftedComputedDeliveryDate: boolean;
  supportsPreOrderOnSalesCampaignDeliveryStart: boolean;
  supportsPreOrderOnSupplierDate: boolean;
  supportsPreOrderOnVariantBlankCell: boolean;
  supportsMinimumVariantQuantityForReOrder: boolean;
  supportsMinimumVariantQuantityForPreOrder: boolean;
  supportsForcedQuantityIncrement: boolean;
  supportsShippingCosts: boolean;
  supportsMinimumOrderTotal: boolean;
  supportsTierFiltering: boolean;
  supportsSeasonReference: boolean;
  supportsContracts: boolean;
  supportsCustomerDiscounts: boolean;
  isDefaultForStoreChannelDiscounts: boolean;
  supportsReOrderCartReason: boolean;
  notificationEmailAddress: string;
  senderEmailAddress: string;
  constructor(init?: Partial<ChannelDTO>) {
    Object.assign(this, init);
  }
}

export class ActiveChannelDTO {
  id: number; //storeChannelId
  storeId: number;
  externalId: string;
  channel: ChannelDTO;
  notificationEmailAddress: string;
  senderEmailAddress: string;
  freeShippingOrderTotalThreshold: number;
  shippingPrice: number;
  constructor(init?: Partial<ActiveChannelDTO>) {
    Object.assign(this, init);
  }
}

export class ChannelMultiselectVM extends ChannelDTO {
  checked: boolean;
  constructor(init?: Partial<ChannelMultiselectVM>) {
    super();
    Object.assign(this, init);
  }
}
export class ChannelDtoMultiselectVM extends ChannelDTO {
  checked: boolean;
  disabled: boolean;
  constructor(init?: Partial<ChannelDtoMultiselectVM>) {
    super();
    Object.assign(this, init);
  }
}

export enum ActiveChannelSupportsEnum {
  channelSupportsStockLimits = 'channelSupportsStockLimits',
  channelSupportsAutomaticDiscounts = 'channelSupportsAutomaticDiscounts',
  channelSupportsManualDiscounts = 'channelSupportsManualDiscounts',
  channelSupportsChannelDiscounts = 'channelSupportsChannelDiscounts',
  channelSupportsVouchers = 'channelSupportsVouchers',
  channelSupportsPreOrders = 'channelSupportsPreOrders',
  channelSupportsPreOrderOnShiftedComputedDeliveryDate = 'channelSupportsPreOrderOnShiftedComputedDeliveryDate',
  channelSupportsPreOrderOnSalesCampaignDeliveryStart = 'channelSupportsPreOrderOnSalesCampaignDeliveryStart',
  channelSupportsPreOrderOnSupplierDate = 'channelSupportsPreOrderOnSupplierDate',
  channelSupportsPreOrderOnVariantBlankCell = 'channelSupportsPreOrderOnVariantBlankCell',
  channelSupportsMinimumVariantQuantityForReOrder = 'channelSupportsMinimumVariantQuantityForReOrder',
  channelSupportsMinimumVariantQuantityForPreOrder = 'channelSupportsMinimumVariantQuantityForPreOrder',
  channelSupportsForcedQuantityIncrement = 'channelSupportsForcedQuantityIncrement',
  channelSupportsFreeShippingOrderTotalThreshold = 'channelSupportsFreeShippingOrderTotalThreshold',
  channelSupportsMinimumOrderTotal = 'channelSupportsMinimumOrderTotal',
  channelSupportsTierFiltering = 'channelSupportsTierFiltering',
  channelSupportsContracts = 'channelSupportsContracts',
}
